import { FieldValues, UseFormSetError } from 'react-hook-form';

import { parseZodError } from '@web/utils/form/parseZodError';
import { trpcClientErrorToZodError } from '@web/utils/trpc/parseTrpcError';

export function defaultFormHandler<TFieldValues extends FieldValues>(
  handler: (values: TFieldValues) => Promise<void>,
  setError: UseFormSetError<any>,
) {
  return async (values: TFieldValues) => {
    try {
      await handler(values);
    } catch (e) {
      const zodError = trpcClientErrorToZodError(e);
      if (zodError) {
        Object.entries(parseZodError(zodError.issues)).forEach(
          ([path, formError]) => {
            setError(path, formError);
          },
        );
      } else if (e instanceof Error) {
        setError('root.server', {
          type: 'server',
          message: e.message,
        });
      }

      throw e;
    }
  };
}
